import React, { useEffect, useState } from 'react';
import { View, Image, Pressable, Keyboard, Platform } from 'react-native';
import gs from '../../../styles/globalStyles';
import OTPVerification from '@sharedComponents/OTPInput/OTPInput';
import {useDarkMode} from '@app/utils';
import { FetchPortfolioError, FetchPortfolioInitResponse } from '../type';
import { getApplicationId, handleFetchPortfolioVerify, handleOtpReport } from '../utils';
import handleApiErr from '@app/helper/handleApiErr';
import { Theme, ThemedView } from '@app/theme';
import { ThemedText } from '@app/theme/Components';
import Button from '@app/sharedComponents/Button/Button';
import ReportOtp from '../../../../assets/Icons/ReportOtp';
import { FetchPortfolioModalType } from '@app/types/regix';
import SMSIconNew from '@app/assets/svg/SMSIconNew';
import EmailIconNew from '@app/assets/svg/EmailIconNew';
import { useTheme } from '@shopify/restyle';

interface VerifyOtpProps {
  otpDigitCount: number;
  source: string;
  email: string;
  applicationId: string;
  assetRepository: string;
  phoneNumber: string;
  onClose: () => void;
  triggerResendOTP?: () => void;
  onVerifySuccess: (data: FetchPortfolioInitResponse) => void;
  setErrorModalData?: (data: FetchPortfolioError | null) => void;
  onRetryFetch?: () => void;
  hasFetchErrorOccured: boolean;
  setHasFetchErrorOccured: (data: boolean) => void;
  retryingFetchPortfolio?: boolean;
  setPortfolioInitData?: (data: FetchPortfolioInitResponse | null) => void;
  title?: string;
}
const getIcon = (source: string, colors: any) => {
    return source === "SMS" ? <SMSIconNew bgColor={colors['bg-fill-primary']} color={colors['icon-emphasis-secondary']} /> 
                : <EmailIconNew bgColor={colors['bg-fill-primary']} color={colors['icon-emphasis-secondary']} />
}
const VerifyOtp: React.FC<VerifyOtpProps> = ({
  otpDigitCount,
  source,
  email,
  phoneNumber,
  applicationId,
  assetRepository,
  onClose,
  onVerifySuccess,
  triggerResendOTP,
  setErrorModalData,
  onRetryFetch,
  hasFetchErrorOccured,
  setHasFetchErrorOccured,
  retryingFetchPortfolio,
  setPortfolioInitData,
  title = 'OTP sent to'
}) => {
  const [hasError, setHasError] = useState<string>('');
  const [verifying, setVerifying] = useState<boolean>(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [isReportingMode,setIsReportingMode] = useState(false)
  const isDarkMode = useDarkMode()
  const {colors} = useTheme<Theme>()


 useEffect(()=>{
// logAmplitudeEvent()
 },[])



  const submitOtp = async (otp: string) => {
    setVerifying(true);
    const _applicationId = await getApplicationId(applicationId);
    await handleFetchPortfolioVerify({
        payload: {
            applicationId: _applicationId,
            assetRepository: assetRepository,
            otp: otp,
        },
        successCallback: async (data: FetchPortfolioInitResponse) => {
            if(
                data?.stepResponseObject?.error &&
                data?.stepResponseObject?.error?.retryNextRTA
            ){
                    const hasErrorOccured = hasFetchErrorOccured;
                    setHasFetchErrorOccured(true);
                    if(retryingFetchPortfolio) {
                      setTimeout(()=> {
                        setErrorModalData &&
                        setErrorModalData({
                          ...data?.stepResponseObject?.error, 
                          retryType: FetchPortfolioModalType.IMMEDIATE
                        });
                      }, Platform.OS !== 'ios' ? 0 : 300);
                    } else if(!hasErrorOccured) {
                        //Reset the error flag
                        if(data?.stepResponseObject?.error?.retryType === FetchPortfolioModalType.IMMEDIATE){
                            //Handle IMMEDIATE case
                            !retryingFetchPortfolio && onRetryFetch && await onRetryFetch();
                            // setErrorModalData && setErrorModalData(null);
                        } else {
                            setPortfolioInitData && setPortfolioInitData(null);
                            setTimeout(()=> {
                              setErrorModalData && setErrorModalData(data?.stepResponseObject?.error);
                            }, Platform.OS !== 'ios' ? 0 : 300);
                            !retryingFetchPortfolio && 
                            setTimeout(async () => {
                                onRetryFetch && await onRetryFetch();
                                // setErrorModalData && setErrorModalData(null);
                            }, data?.stepResponseObject?.error?.loaderTimingInMilliSec);
                        }
                    } else {
                        setTimeout(()=> {
                          setErrorModalData && setErrorModalData({
                            ...data?.stepResponseObject?.error,
                            retryType: FetchPortfolioModalType.IMMEDIATE
                        });
                        }, Platform.OS !== 'ios' ? 0 : 300);
                    }
                    setPortfolioInitData && setPortfolioInitData(null);
            } else {    
                onVerifySuccess(data);
            }
            setVerifying(false);
        },
        errorCallback: (error: any) => {
            setHasError(error?.data?.message);
            setVerifying(false);
            if (
              error?.status === 400 && (
                error?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP' ||
                error?.data?.voltErrorCode === 'MF_OTP_ATTEMPTS_EXHAUSTED'
              )
            ) {
              setIsBlocked(true);
              Keyboard.dismiss();
            } else if (error?.data?.statusCode && handleApiErr(error)) {
                // dispatch(showErrorSheet({
                //     isErrorSheetVisible: true,
                //     errorMessage: error?.data?.message,
                //     closeOnBackdropPress: true,
                //     errorType: error?.data?.voltErrorCode || error?.data?.statusCode,
                //     errorHeading: error?.data?.header,
                //     showErrorHeading: true,
                //     btnName: 'Ok, got it!',
                // }))
            }
        }
    })
  };

  const reportOtpIssue = async () => {
     handleOtpReport({
      payload: {
          uniqueId: applicationId,
          uniqueIdentifierType: `MF_FETCH_PORTFOLIO_${assetRepository}`,
      }

  })
  }

//  const logAmplitudeEvent = () => {

//   Sentry.captureMessage('Custsssomer Facing Isssssssue')
  
//  }

  const handleOtpInput = (otp: string[]) => {
    if (isBlocked) {
      return;
    }

    const OTP = otp.join('');
    if (OTP.length === otpDigitCount) {
      submitOtp(OTP);
    } else if (OTP.length > 0 && hasError !== '') {
      setHasError('');
    }
  };

  return isReportingMode? (<>
     <ThemedView alignItems='center' padding='lg'>
      <ReportOtp />
      <ThemedText variant='h5s'>Request Received</ThemedText>
    <ThemedText textAlign='center' marginTop='sm' variant='b3r'>
    {"Thanks for the feedback, We are working on the issue, please try again shortly."}    </ThemedText>

        <Button handlePress={()=>{
          onClose()
          setTimeout(()=>{
            setIsReportingMode(false)

          },1000)
          
        }}
        overRideStyle={{marginTop:24}}
        label='Got it'
        />
      </ThemedView>
  
  </>) :  (
    <>
      <View style={[gs.setPadding(16), gs.setMarginTop(8)]}>
        <View style={[gs.flexRow, gs.spaceBetween]}>
          <View
            style={[
              gs.setMarginBottom(16),
            ]}>
          <ThemedText color='text-primary' variant='h3b'>{`Enter ${otpDigitCount}-digit OTP`}</ThemedText>
          </View>
          {/* <Pressable onPress={onClose}>
            <X size={24} color={isDarkMode?'#fff':'#000'}/>
          </Pressable> */}
        </View>

        <ThemedView
          bg='bg-fill-emphasis-secondary'
          borderColor='border-emphasis-secondary'
          style={[
            gs.flexRow,
            {
              borderRadius: 12,
              borderWidth: 1,
              padding: 12,
            },
            gs.setMarginBottom(16),
          ]}>
          {
             getIcon(source, colors)
          }
          <View style={[gs.setMarginLeft(12)]}>
            <ThemedText variant='b4r' color='text-primary'>{title}</ThemedText>
   
            <View style={{marginTop:3}}>
              <ThemedText color='text-secondary' variant='b3r'>{phoneNumber}</ThemedText>
      
            </View>
          </View>
        </ThemedView>
        <OTPVerification
          noOfDigits={otpDigitCount}
          hasError={hasError}
          handleOtpInput={handleOtpInput}
          resendTimerCount={15}
          triggerResendOTP={
            triggerResendOTP 
            ? triggerResendOTP 
            : ()=>{}
          }
          verifying={verifying}
          onCustomerFacingIssue={()=>{
            reportOtpIssue()
            // logSentryEvent()
            setIsReportingMode(true);
          }}
          blockResend={isBlocked}
          isDarkMode={Boolean(isDarkMode)}
        />
      </View>
    </>
  );
};
export default VerifyOtp;
